import { forwardRef, PropsWithChildren } from 'react';
import { Box, Flex, BoxComponentProps, ElementProps } from '@mantine/core';
import { Text } from 'components/text/Text';
import styles from './Row.module.css';
import { joinClassNames } from 'utils/joinClassNames';

export const Row = forwardRef<
    HTMLTableRowElement,
    PropsWithChildren<
        BoxComponentProps & ElementProps<'tr'> & { disableBorders?: boolean; isDisabled?: boolean }
    >
>(({ children, className, disableBorders, isDisabled, ...props }, ref) => (
    <Box
        className={joinClassNames(
            className,
            disableBorders ? styles.disableRowBorders : styles.rowBorders,
            isDisabled ? styles.disabled : undefined
        )}
        component={'tr'}
        tabIndex={0}
        ref={ref}
        {...props}
    >
        {children}
    </Box>
));

Row.displayName = 'Row';

export const Data = ({
    isReversed,
    width,
    children,
    style,
    className,
    isDisabled,
    ...props
}: {
    isReversed?: true;
    width?: BoxComponentProps['w'];
    isDisabled?: boolean;
} & BoxComponentProps &
    PropsWithChildren<unknown>) => {
    return (
        <Box
            className={joinClassNames(styles.data, isDisabled ? styles.disabled : undefined, className)}
            w={width ?? undefined}
            style={{
                minWidth: width ? undefined : '146px',
                ...style,
            }}
            component={'td'}
            {...props}
        >
            <Flex direction={isReversed ? 'row-reverse' : 'row'}>
                <Text size={'sm'} span>
                    {children}
                </Text>
            </Flex>
        </Box>
    );
};
